export async function getMicStream() {
  if (!navigator.mediaDevices?.getUserMedia || typeof window.MediaRecorder === "undefined") {
    throw Object.assign(new Error("unsupported"), { name: "NotSupportedError" });
  }
  return navigator.mediaDevices.getUserMedia({ audio: true });
}

export function micErrorMessage(e) {
  switch (e?.name) {
    case "NotAllowedError":
    case "SecurityError":
      return "Microphone access is blocked. Allow mic access for studivault.com in your browser's site settings, then try again.";
    case "NotFoundError":
    case "OverconstrainedError":
      return "No microphone found. Plug in or enable a mic, then try again.";
    case "NotReadableError":
    case "AbortError":
      return "Your microphone is busy in another app or tab. Close it there and try again.";
    case "NotSupportedError":
      return "This browser can't record audio. Try the latest Chrome, Edge, Safari or Firefox.";
    default:
      return "Couldn't start the microphone. Check your mic and browser permissions, then try again.";
  }
}
